/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCellularSignalOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m23.707 22.293-1.414 1.414L20.586 22H2.136l9.087-9.363L.293 1.707 1.707.293zM6.864 20h11.722l-5.95-5.95zM22 18.086l-2-2v-9.62l-4.738 4.882-1.415-1.415L22 1.534z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCellularSignalOff as CellularSignalOff };
